import React, { useEffect } from 'react';

import DocList from 'pages/Document/DocList';
import DF from 'DisplayFramework';
import FormInput from 'components/FormInput';
import ParListSelect from 'components/ParListSelect';
import { Form, FormInstance, Row } from 'antd';
import { shouldUpdateCompare } from 'utils/utils2';
import TextArea from 'antd/lib/input/TextArea';
import Value from 'components/Value';

export type TabUploadProps = {
  objectid: number;
  object: string;
  form: FormInstance;
};

const TabTpinvestigation = ({ object, objectid, form }: TabUploadProps) => {
  useEffect(() => {
    form.setFieldsValue({
      tpstatustype: 'STATUS',
    });
  }, []);
  return (
    <DF.Provider pagcode="tabtpinvestigation">
      <DocList
        objectid={objectid}
        tpid={objectid}
        hideBtn
        objecttype={object}
        doccode="INVESTIGAT"
        applyFilter={false}
        pagination={false}
      />
      <Row style={{ marginTop: 30 }} gutter={30}>
        <FormInput col md={8} name="tpstatustarget">
          <ParListSelect
            allowClear
            parcode="INVESTDEC"
            onSelect={() => {
              form.setFieldsValue({ motif: '' });
            }}
          />
        </FormInput>
        <FormInput col md={8} name="tpstatustype" style={{ display: 'none' }}>
          <Value />
        </FormInput>
        <Form.Item shouldUpdate={shouldUpdateCompare('tpstatustarget')} noStyle>
          {({ getFieldValue }) => {
            return (
              <FormInput col md={8} name="motif">
                <ParListSelect
                  allowClear
                  parcode="REFREASON"
                  parvalueparent={getFieldValue('tpstatustarget')}
                />
              </FormInput>
            );
          }}
        </Form.Item>
      </Row>
      <Row style={{ marginTop: 10 }}>
        <FormInput labelCol={{ span: 24 }} col md={24} name="authcomment">
          <TextArea rows={5} />
        </FormInput>
      </Row>
    </DF.Provider>
  );
};

export default TabTpinvestigation;
